import { Injectable } from '@angular/core'
import { UserService } from './user/user.service'
import { UserRoleService } from './user-role/user-role.service'
import { AppDashboardService } from './app-dashboard/app-dashboard.service'
import { PermissionsService } from './permissions/permissions.service'
import { AuthProviderService } from './auth-provider/auth-provider.service'
import { PluginService } from './plugin/plugin.service'
import { AppPluginService } from './app-plugin/app-plugin.service'
import { AppPluginWidgetService } from './app-plugin-widget/app-plugin-widget.service'
import { NgsiSubscriptionWidgetService } from './ngsi-subscription-widget/ngsi-subscription-widget.service'
import { PublicViewService } from './public-view/public-view.service'
import {PluginUserDataService} from "./plugin_user_data/plugin-user-data.service";
import {AppGlobalSettingsService} from "./app-global-settings/app-global-settings.service";


@Injectable({
  providedIn: 'root'
})
export class ModelService {
  constructor(
    public _user: UserService,
    public _userRole: UserRoleService,
    public _appDashboard: AppDashboardService,
    public _permissions: PermissionsService,
    public _authProvider: AuthProviderService,
    public _plugin: PluginService,
    public _appPlugin: AppPluginService,
    public _appPluginWidget: AppPluginWidgetService,
    public _plugin_user_data: PluginUserDataService,
    public _ngsiSubscriptionWidget : NgsiSubscriptionWidgetService,
    public _publicView: PublicViewService,
    public _appGlobalSettings: AppGlobalSettingsService,
  ) {}
}
